import React, { useEffect, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectUser } from '../store/user';
import { submitPublicFeatureRequest } from '../lib/featureRequests';

function Feedback() {
  const user = useSelector(selectUser).data;
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [impact, setImpact] = useState('');
  const [website, setWebsite] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (user?.details) {
      setName(`${user.details.name || ''} ${user.details.surname || ''}`.trim());
      setEmail(user.details.email || '');
    }
  }, [user]);

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await submitPublicFeatureRequest({
        name,
        email,
        title,
        description,
        impact,
        source: 'cp-redesign',
        website,
      });
      setSubmitted(true);
      setTitle('');
      setDescription('');
      setImpact('');
    } catch (err) {
      setError(err.message || 'Could not submit your suggestion.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          {submitted ? (
            <>
              <h1 className="h4 fw-bold mb-2">Suggestion sent</h1>
              <p className="text-muted mb-4">
                Thanks for sharing your idea. It has been saved and emailed to the product team.
              </p>
              <Button variant="danger" onClick={() => setSubmitted(false)}>
                Suggest another
              </Button>
            </>
          ) : (
            <>
              <h1 className="h4 fw-bold mb-2">Suggest a feature</h1>
              <p className="text-muted mb-4">
                Tell us what would make ClinicPlus Companion or the booking site more useful for
                your team.
              </p>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={submit}>
                <Form.Group className="mb-3">
                  <Form.Label>Your name</Form.Label>
                  <Form.Control value={name} onChange={(e) => setName(e.target.value)} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Feature title</Form.Label>
                  <Form.Control
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="e.g. Bulk export appointment invoices"
                    required
                    maxLength={120}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>What should it do?</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    maxLength={2000}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Why would this help? (optional)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={impact}
                    onChange={(e) => setImpact(e.target.value)}
                    maxLength={1000}
                  />
                </Form.Group>
                <div style={{ display: 'none' }} aria-hidden="true">
                  <Form.Control
                    tabIndex={-1}
                    autoComplete="off"
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                  />
                </div>
                <Button type="submit" variant="danger" disabled={submitting}>
                  {submitting ? 'Submitting…' : 'Submit suggestion'}
                </Button>
              </Form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Feedback;
